import React, { memo } from 'react';

import { useImagesContext } from '@/context/ImagesContext';
import { getImageDisplayUrl } from '@/utils/images';

import { ContactsListItem } from './components';
import { Props } from './types';

function ContactsList({
    clickable,
    multiSelect = true,
    selectCondition,
    conditionWarning,
    items,
    extraItems,
    testIdPrefix,
    selectable,
    selectedItems,
    onItemClick,
    onRemove,
    removable,
    itemWrapperStyle,
    size = 'normal',
    displayContactInformation,
    renderExtraContentComponent,
    renderWholeContentComponent,
    renderExtraItemComponent,
    selectLimit,
}: Props) {
    const { images, ImagesService } = useImagesContext();

    const reachedOutMaximumCapacity =
        selectLimit && selectedItems && selectedItems.size >= selectLimit;

    return (
        <>
            {renderExtraItemComponent &&
                extraItems &&
                extraItems.length > 0 &&
                extraItems.map(renderExtraItemComponent)}
            {items.map((contact) => {
                const avatarUrl = getImageDisplayUrl(
                    ImagesService.getSingleImageByEntityId(images, contact.id),
                );

                return (
                    <ContactsListItem
                        testID={`${testIdPrefix}-ContactsListItem`}
                        key={contact.id}
                        clickable={clickable}
                        contact={contact}
                        onRemove={onRemove}
                        isSelected={selectedItems && selectedItems.has(contact)}
                        onClick={onItemClick}
                        selectable={selectable}
                        removable={removable}
                        size={size}
                        wrapperStyles={itemWrapperStyle}
                        avatarUrl={avatarUrl}
                        multiSelect={multiSelect}
                        selectCondition={selectCondition}
                        conditionWarning={conditionWarning}
                        isSelectionLimitReached={reachedOutMaximumCapacity}
                        displayContactInformation={displayContactInformation}
                        renderExtraContentComponent={
                            renderExtraContentComponent
                        }
                        renderWholeContentComponent={
                            renderWholeContentComponent
                        }
                    />
                );
            })}
        </>
    );
}

export default memo(ContactsList) as (props: Props) => JSX.Element;
